import React from 'react'
import { Link } from 'react-router-dom'

const SavingsAccountForm = () => {
    return (
        <form>
            {/* x---------------------------------x Personal Information x---------------------------------x */}
            <div className="row form-section g-3">
                <h4 className='text-dark fs-5 fw-semibold'>Personal Information</h4>
                <div className="col-md-6 form-group">
                    <label htmlFor="firstName">First Name</label>
                    <input type="text" className="form-control-lg form-control"
                        id="firstName" placeholder="Enter your first name"
                        required />
                </div>
                <div className="col-md-6 form-group">
                    <label htmlFor="lastName">Last Name</label>
                    <input type="text" className="form-control-lg form-control"
                        id="lastName" placeholder="Enter your last name"
                        required />
                </div>
                <div className="col-md-6 form-group">
                    <label htmlFor="dob">Date of Birth</label>
                    <input type="date" className="form-control-lg form-control"
                        id="dob" required />
                </div>
                <div className="col-md-6 form-group">
                    <label htmlFor="ssn">Social Security Number (SSN)</label>
                    <input type="text" className="form-control-lg form-control"
                        id="ssn" placeholder="Enter your SSN" required />
                </div>
                <div className="col-md-6 form-group">
                    <label htmlFor="address">Address</label>
                    <input type="text" className="form-control-lg form-control"
                        id="address" placeholder="Enter your address" required />
                </div>
                <div className="col-md-6 form-group">
                    <label htmlFor="email">Email address</label>
                    <input type="email" className="form-control-lg form-control"
                        id="email" placeholder="Enter your email" required />
                </div>
                <div className="col-md-6 form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input type="tel" className="form-control-lg form-control"
                        id="phone" placeholder="Enter your phone number"
                        required />
                </div>
                <div className="col-md-6 form-group">
                    <label htmlFor="accountType">Account Type</label>
                    <select className="form-control-lg form-control"
                        id="accountType" required>
                        <option value="">Select Account Type</option>
                        <option value="standard">Standard Savings</option>
                        <option value="high-yield">High-Yield Savings</option>
                    </select>
                </div>
                <div className="col-md-6 form-group">
                    <label htmlFor="initialDeposit">Initial Deposit Amount
                        ($)</label>
                    <input type="number" className="form-control-lg form-control"
                        id="initialDeposit" placeholder="Enter deposit amount"
                        min="0" required />
                </div>
            </div>

            {/* x---------------------------------x Terms and Conditions x---------------------------------x */}
            <div className="form-check my-3">
                <input type="checkbox" className="form-check-input" id="terms"
                    required />
                <label className="form-check-label" htmlFor="terms">I agree to the <Link
                    to="/savings-accounts">terms and conditions</Link>.</label>
            </div>

            {/* x---------------------------------x Submit Button x---------------------------------x */}
            <button type="submit" className="btn btn-primary mt-3">Submit Application</button>
        </form>
    )
}

export default SavingsAccountForm